import { Skeleton, SkeletonProps } from "@chakra-ui/react";
import { ReactNode } from "react";

type Props = SkeletonProps & {
  isLoading?: boolean;
  children: ReactNode;
};

const defaultWidth = "120px";

export const PriceLoadingSkeleton = ({ children, isLoading, ...props }: Props) => {
  return (
    <Skeleton
      isLoaded={!isLoading}
      h="24px"
      minW={defaultWidth}
      maxW={defaultWidth}
      w={defaultWidth}
      {...props}
    >
      {children}
    </Skeleton>
  );
};
